<script>
import { QInput } from 'quasar'
import { BloodUnit } from '@/lib/enums'
export default {
  functional: true,
  props: {
    unit: {
      type: Number,
      validator: function (val) {
        return BloodUnit.items.includes(val)
      }
    }

  },
  render: function (createElement, { props, data, children }) {
    if (props.unit === BloodUnit.Ml) {
      Object.assign(props, {
        mask: '#',
        rules: val => Number.isInteger(val) || '格式不正确'
      })
    } else {
      Object.assign(props, {
        mask: '#.#',
        rules: val => /^[0-9](\.[0-9])?$/.test(val) || '格式不正确'
      })
    }
    return createElement(QInput, {
      props: props
    }, data, children)
  }
}
</script>
